<ng-template #AddStore let-modal>
    <div class="modal-header">
        <h5 class="modal-title mt-0">Add Store</h5>
    </div>
    <div class="modal-body">
        <div class="container">
            <h3 class="mb-2">Add Your Shop</h3>
            <p class="text-muted mb-4">Please select the options that fits you best</p>

            <div class="row justify-content-center">
                <div class="col-6">
                    <div class="card border border-light shadow-sm mb-1 text-center" (click)="goToAddStore('shopify')">
                        <img src="assets/images/Shopify-Logo.png" alt="Shopify Logo"
                            class="img-fluid mx-auto d-block mb-2" style="max-height: 150px;">
                        <p class="text-success px-3">I want to connect my Shopify Store</p>
                    </div>
                </div>

                <div class="col-6">
                    <div class="card border border-light shadow-sm mb-1 text-center" (click)="goToAddStore('custom')">
                        <img src="assets/images/custom-store.png" alt="Custom Store Logo"
                            class="img-fluid mx-auto d-block mb-2" style="max-height: 150px;">
                        <p class="text-secondary px-2 custom">I want to connect my Custom Store</p>
                    </div>
                </div>
                <div class="col-12 mt-3">
                    <button class="btn btn-block btn-outline-secondary" (click)="closePopup()">I will add my Store Later</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #goToShopifyStore let-modal>
    <div class="modal-body">
        <div class="row d-flex flex-row justify-content-center">
            <div class="spinner-border text-success mb-3 mt-3" style="width: 8rem; height: 8rem; border-width: .5em;"
                role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="col-12 d-flex flex-row justify-content-center mb-3 px-4">
                <h5 class="text-center">Please open the Kainic App from your Shopify Store in order to load your store
                    settings.</h5>
            </div>
            <div class="col-12 d-flex flex-row justify-content-between mb-2">
                <button type="button" class="col-6 btn btn-outline-success" (click)='goToMyStore()'>Go to my
                    Store</button>
                <button type="button" class="col-6 btn btn-outline-secondary"
                    (click)='closePopup()'>I will add my Store Later</button>
            </div>
        </div>
    </div>
</ng-template>
